var _mask, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOuterEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_267_2758",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#F8F9FA",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_267_2758)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuterEye);
export default __webpack_public_path__ + "static/media/outer-eye.9874e2ed3b5798a896d252f64b0fa135.svg";
export { ForwardRef as ReactComponent };